import { Url } from '../general/modules/url';
import { EmailRegistration } from './emailRegistration';

export class LandingEmailRegistration extends EmailRegistration {
    protected static getAction() {
        return 'lpregistration';
    }

    protected static getRegistrationEndpoint() {
        return Url.getNoLangUrl('/lpregistration');
    }
}
